/* ---------------------------------
GLOBAL FUNCTIONS - PRICE FORMATTING
Formato de la tienda: ${{amount_no_decimals}} COP (sin decimales, coma como separador de miles)
---------------------------------*/

//Con esta función pasamos $5,302 a 5302. La coma y el punto son separadores de miles (formato COP sin decimales).
function getPriceFromString(value) {
  // Eliminar el símbolo de moneda y los separadores de miles (coma y punto)
  let cleanValue = value.replace(/[^\d]/g, "");

  // Convertir a número
  return parseFloat(cleanValue);
}

//Con esta función pasamos 6500 a $6,500. La coma es separador de miles (formato COP sin decimales).
function getPriceFromNumber(value, type = "default") {
  // Redondear hacia abajo para obtener un número entero
  let roundedValue = Math.floor(value).toString();

  let formattedValue = roundedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Si el tipo es default, añadir el símbolo de $
  return type === "default" ? `$${formattedValue}` : formattedValue;
}
